import React, { useState } from "react";
import QueryBuilder from "../QueryBuilder/Querybuilder";
import logo from "../../assets/logo.png";
import { Button, Modal, Form, Input, Select, message, Row, Col } from "antd";
const Assigne = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Form Values:", values);
    handleAddAssigne(values);
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
    form.resetFields();
  };
  const handleAddAssigne = async (values) => {
    debugger;
    const dataToSend = {
      name: values.assigne,
    };

    try {
      const response = await fetch("/api/portal/pms/add_pms_assignee", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        message.success("Source added successfully");
        setModalVisible(false);
        form.resetFields();
      } else {
        message.error("Failed to add source");
      }
    } catch (error) {
      message.error("Error adding source");
      console.error("Error:", error);
    }
  };
  return (
    <div>
      <Modal
        open={modalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
        title="Public Grievance Form"
        width={1000}
        style={{ top: 20, left: "6%" }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            style={{ width: 60, marginRight: 20 }}
            alt="Pulse Logo"
          />
          <h2 style={{ margin: 0 }}>Janasena</h2>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: 20 }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="assigne"
                label="Add Assigne"
                rules={[
                  { required: true, message: "Please enter your assigne" },
                ]}
              >
                <Input placeholder="Enter your assigne" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <QueryBuilder
        title={"Assigne"}
        Headername={"/api/portal/reports/getTablemetadata/"}
        Rulesdata={"/api/portal/reports/getFilters/"}
        Databyquery={"/api/portal/reports/getDatabyquery/"}
        id={52}
        addassigne={true}
        addassigneepet={showModal}
      />
    </div>
  );
};

export default Assigne;
